"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Link_1 = __importDefault(require("shared/components/Link"));
var utils_1 = require("../utils");
var OwnerAssign = function (_a) {
    var notifs = _a.notifications;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, utils_1.listUsers)((0, utils_1.groupAndSortUsers)(notifs)) || 'A colleague', " designated you as billing owner of", ' ', (0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ to: "/my-stack?default_mine=1" }, { children: [notifs.length, " tool", notifs.length > 1 && 's'] })), "."] }));
};
exports.default = OwnerAssign;
